import { GlobalResponseObject } from "../../global-response-object";


export class UserStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}

